import React, { useState } from 'react';
import Icon from '../AppIcon';

const PrivacyToggle = () => {
  const [isPrivateMode, setIsPrivateMode] = useState(false);

  const handleToggle = () => {
    setIsPrivateMode(!isPrivateMode);
  };

  return (
    <div className="fixed top-4 right-4 z-notification lg:top-[70px]">
      <button
        onClick={handleToggle}
        className={`
          flex items-center space-x-2 px-4 py-2 rounded-md
          transition-therapeutic shadow-therapeutic
          ${isPrivateMode
            ? 'bg-accent text-accent-foreground'
            : 'bg-card text-foreground border border-border'
          }
        `}
        aria-label={isPrivateMode ? 'Switch to shared view' : 'Switch to private view'}
      >
        <Icon 
          name={isPrivateMode ? 'Lock' : 'Users'} 
          size={18} 
          color="currentColor"
        />
        <span className="text-sm font-medium font-caption hidden sm:inline">
          {isPrivateMode ? 'Private' : 'Shared'}
        </span>
      </button>
    </div>
  );
};

export default PrivacyToggle;